import moment from "moment"
import { FormTypeAdd } from "utils/Constant"
import { GetStatus } from "utils/helpers"

export const FilterCard = ({ title, children, width='sm:w-72 w-full' }) => {
    return (
        <div className={'flex flex-col gap-1 ' + width}>
            <span className="text-sm">{ title }</span>
            { children }
        </div>
    )
}

export const FormCard = ({ title, children }) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center sm:min-h-10 text-sm">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}

export const PagesTitle = ({ title }) => {
    return (
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-xl">{title}</span>
            </div>
            <hr />
        </div>
    )
}

export const PagesFormTitle = ({ title, formType, status, createDate, updateDate, updateBy }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-xl">{ title }</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />
        </div>
    )
}

export const SidebarCard = ({ title, path, isOpen, onClick, children }) => {
	return(
		<a
			className={`w-full py-3 cursor-pointer transition-all rounded-md flex items-center text-sm
				${ window.location.pathname.includes(path) ? 'font-bold' : '' } 
				${ isOpen ? 'px-4' : 'justify-center px-2' }
			`}
			onClick={onClick}
			href={ path }
		>
			{ children }
			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>{ title }</p>
		</a>
	)
}

export const MainBodyCard = ({ children }) => {
    return (
        <div className="p-3 h-screen overflow-hidden">
            <div className="w-full h-full bg-white sm:border rounded-xl sm:p-6 flex flex-col overflow-auto">
                { children }
            </div>
        </div>
    )
}